<template>
  <div class="container step--data sm:container lg:mt-8">
    <div class="lg:flex justify-between items-baseline lg:mt-10 mt-4 lg:mb-6">
      <button @click="$router.push({name: 'reserve-area-summary'})">
        <div class="flex justify-start items-start -ml-3">
          <v-icon left size="30"> mdi-chevron-left </v-icon>
          <p class="mt-1 -ml-1">{{$t('shared.back')}}</p>
        </div>
      </button>
      <div class="lg:mb-8 lg:mt-10 mt-4 mb-4 w-full">
        <h1 class="title-reserve text-center mb-4 leading-9 font-bold">
          {{$t('reservation_area.add_extras')}}
        </h1>

        <h3 class="avenir text-center text-xl font-bold">
          {{$t('reservation_area.reservation_code')}}:<span class="avenir code-res font-bold ml-2">{{
            reservation.code
          }}</span>
        </h3>
      </div>
    </div>
    <div class="lg:flex">
      <div class="resume-extra-left w-full">
        <p class="avenir font-bold text-xl pt-6 mb-6">
          {{$t('reservation_area.select_extras')}}
        </p>
        <div class="extras-personalize" v-if="extrasToAdd.length !== 0">
          <div class="lg:mt-12 mt-6">
            <app-box-booking
              v-for="extra in extrasToAdd"
              :key="extra.id"
              class="px-6 mb-6"
            >
              <app-box-checkbox
                :id="extra.id"
                :slug="extra.slug"
                :selected="!!getSelectedExtraById(extra.id)"
                :title="extra.title"
                :copy="extra.description"
                :isCuatitative="extra.has_counter === 1"
                :counter-is-disabled="!getSelectedExtraById(extra.id)"
                :quantity="extraQuantity(extra.id)"
                :price="getExtraPrice(extra.id)"
                :counter-max-value="getPassengersCount"
                :counter-min-value="1"
                v-on:checkboxChange="toggleExtra(extra.id)"
                v-on:counterChange="changeExtraQuantity"
              />
            </app-box-booking>
          </div>
        </div>

        <app-box-header
          v-for="(passenger, index) in newPassengers"
          :key="passenger.id"
          :title="getPassengerLabel(passenger.type, index)"
          :name="passenger.name"
          :last-name="passenger.last_name"
          class="mb-6"
        >
          <h3 class="font-bold mb-3">Equipaje</h3>
          <bags-component
            v-for="extra in bagsToAdd(passenger)"
            :key="extra.id"
            :extra="extra"
            :passenger="passenger"
            @handleClick="changeStatus"
          ></bags-component>
        </app-box-header>

        <div v-if="reservation.destination" id="resume" class="lg:hidden resume-extra-right w-full block mb-6">
          <app-box-extras
            :destiny="reservation.destination.name"
            :destinyCode="reservation.destination.code"
            :departure="reservation.origin.name"
            :departureCode="reservation.origin.code"
            :arrivalTime="reservation.inbound_arrival_time"
            :departureTime="reservation.inbound_departure_time"
            :returnArrivalTime="reservation.outbound_arrival_time"
            :returnDepartureTime="reservation.outbound_departure_time"
            :getPassengers="total_passengers"
          >
          </app-box-extras>
        </div>

        <div v-if="showPaymentMethods">
          <payment-methods-component
            ref="paymentMethods"
            extras
          ></payment-methods-component>
          <terms-component v-bind:promotions.sync="promotions" />
          <comfirmation-component
            @submit-step="submit"
            @show-overlay-to-false="showOverlay = false"
            @show-paypal-to-false="showPaypal = false"
            @paypal-approved="scrollToBottom"
            :showPaypal="showPaypal"
            :showOverlay="showOverlay"
            reserveArea
            extras
          ></comfirmation-component>
        </div>
      </div>

      <div
        v-if="reservation.destination"
        id="resume"
        class="hidden lg:block resume-extra-right w-1/2 lg:ml-16 lg:pt-6"
      >
        <app-box-extras
          :destiny="reservation.destination.name"
          :destinyCode="reservation.destination.code"
          :departure="reservation.origin.name"
          :departureCode="reservation.origin.code"
          :arrivalTime="reservation.inbound_arrival_time"
          :departureTime="reservation.inbound_departure_time"
          :returnArrivalTime="reservation.outbound_arrival_time"
          :returnDepartureTime="reservation.outbound_departure_time"
          :getPassengers="total_passengers"
        >
        </app-box-extras>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  GET_AVALIABLE_EXTRAS,
  GET_BAGS_TO_ADD,
  GET_EXTRAS_TO_ADD,
  GET_EXTRA_BY_ID,
  GET_EXTRA_UNIT_PRICE,
  GET_NEW_EXTRAS,
  GET_NEW_PASSENGERS,
  GET_PASSENGERS,
  GET_RESERVATION,
  GET_SELECTED_EXTRA_BY_ID,
  GET_TOTAL_BONUS,
  GET_TOTAL_PASSENGERS
} from "../../store/reserve-area/getter-types";
import passengerLabel from "../../utils/mixins/passengerLabel";
import BagsComponent from "../../pages/nights/common/BagsComponent.vue";
import FixedBookingSummary from "../../modules/booking/components/Stepper/FixedBookingSummary/FixedBookingSummary.vue";
import { SET_TERMS } from "../../store/booking/mutation-types";
import { GET_TERMS } from "../../store/booking/getter-types";
import { SET_STEPPER_LOADING } from "../../store/stepper/mutation-types";
import { GET_PAYMENT_METHOD } from "../../store/getter-types";
import {
  SET_EXTRA_QUANTITY,
  TOGGLE_EXTRA,
  TOGGLE_PASSENGER_BAG
} from "../../store/reserve-area/mutation-types";

export default {
  components: {
    BagsComponent,
    FixedBookingSummary
  },
  mixins: [passengerLabel],
  data() {
    return {
      showPaypal: false,
      showOverlay: false
    };
  },
  computed: {
    showPaymentMethods() {
      let someBag = false;
      this.newPassengers.map(p => {
        if (p.bags.length > 0) someBag = true;
      });

      return this.newExtras.length > 0 || someBag;
    },
    promotions: {
      get() {
        return this.$store.state.nights.newsletter;
      },
      set(promotions) {
        this.$store.commit(NIGHTS_SET_STATE, ["newsletter", promotions]);
      }
    },
    terms() {
      return this.$store.getters[GET_TERMS].terms.value;
    },
    paymentMethod() {
      return this.$store.getters[GET_PAYMENT_METHOD];
    },
    ...mapGetters({
      getPassengersCount: GET_TOTAL_PASSENGERS,
      getExtraById: GET_EXTRA_BY_ID,
      getSelectedExtraById: GET_SELECTED_EXTRA_BY_ID,
      getExtraPrice: GET_EXTRA_UNIT_PRICE,
      passengers: GET_PASSENGERS,
      extrasAvaliable: GET_AVALIABLE_EXTRAS,
      reservation: GET_RESERVATION,
      total_passengers: GET_TOTAL_PASSENGERS,
      newPassengers: GET_NEW_PASSENGERS,
      newExtras: GET_NEW_EXTRAS,
      totalBonus: GET_TOTAL_BONUS,
      extrasToAdd: GET_EXTRAS_TO_ADD
    })
  },
  methods: {
    changeStatus(payload) {
      if (!payload.included) {
        this.$store.commit(TOGGLE_PASSENGER_BAG, {
          passengerId: payload.passengerId,
          bagId: payload.bagId
        });
      }
    },
    bagsToAdd(passenger) {
      const bagsAvaliable = this.$store.state.nights.resources.bags;

      const passengerLoaded = this.passengers.find(p => p.id === passenger.id);

      return bagsAvaliable.filter(bagAvaliable => {
        if (bagsAvaliable.included) return false;

        return passengerLoaded.bags.every(
          bagAdded => bagAdded.description != bagAvaliable.description
        );
      });
    },
    extraQuantity(extraId) {
      const extra = this.getSelectedExtraById(extraId);
      if (!extra) return 0;
      return extra.has_counter ? extra.quantity : 0;
    },
    toggleExtra(extraId) {
      this.$store.commit(TOGGLE_EXTRA, extraId);
    },
    changeExtraQuantity(quantity, extraId) {
      this.$store.commit(SET_EXTRA_QUANTITY, { quantity, extraId });
    },
    validate() {
      return this.validateTerms();
    },
    validateTerms() {
      this.$store.commit(SET_TERMS, {
        ...this.$store.getters[GET_TERMS],
        terms: {
          error: !this.terms,
          value: this.terms
        }
      });
      if (!this.terms) {
        this.$toastr.e(this.$i18n.messages[this.$i18n.locale].toast.error_11);
      }
      return this.terms;
    },
    retrievePaymentParameters() {
      this.$refs.paymentMethods.$refs.redsysComponent.retrievePaymentParameters();
    },
    submit() {
      if (!this.validate()) {
        this.$store.dispatch(SET_STEPPER_LOADING, false);
        return;
      }

      if (this.paymentMethod == "paypal") {
        this.showPaypal = true;
        this.showOverlay = true;
        const paypalContainer = document.getElementById("submitContainer");

        window.scrollTo({
          top: paypalContainer.offsetTop,
          left: 0,
          behavior: "smooth"
        });
      } else this.retrievePaymentParameters();
    },
    scrollToBottom() {
      if (window.matchMedia("(min-width: 1280px)").matches) {
        window.scrollTo(0, 9999);
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../../sass/variables";
.step--data {
  font-family: $avenir;
  .code-res {
    color: $turquoiseBlue;
  }
  .title-reserve {
    font-size: 2.6rem;
    font-family: $avenirHeavy;
    @media (max-width: 640px) {
      font-size: 1.9rem;
    }
  }
  .theme--light.v-icon {
    color: #000;
  }
  .avenir {
    font-family: $avenirHeavy;
  }
}
</style>
